<script>
	import { getContext } from "svelte";

	import draftsStore from "../../../../stores/data/draftsStore.js";

	import Fetcher from "../../../../api/Fetcher";
	import Icon from "../../../icons/small/Icon.svelte";

	export let draftId;

	const draftDeleted = getContext("draftDeleted");

	let confirm = false;
	let deleting = false;

	function handleClick() {
		if (!confirm) {
			confirm = true;
			setTimeout(() => (confirm = false), 2500);
			return;
		}
		confirm = false;
		deleting = true;
		Fetcher.deleteDraft({ draftId }).then(handleDraftDeleted);
	}

	function handleDraftDeleted() {
		draftDeleted(draftId);
		draftsStore.fetchDrafts();
	}
</script>

{#if !deleting}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		class="my-auto text-error tooltip"
		data-tip={confirm ? "Sure?" : "Delete"}
		on:click={handleClick}
	>
		<Icon name={confirm ? "questionMarkCircle" : "bin"} />
	</div>
{/if}
